import(/* webpackMode: "eager" */ "/app/src/app/[shareId]/page.tsx");
